export default __webpack_public_path__ + "static/media/voucherGTS1.4145e7e6.jpg";